import { Card, Col, Row } from 'antd';
import React from 'react';
import Header from "../../components/header"
import "./portfolio.less"
import vendexpresslogo from "../../asset/vendexpresslogo.svg"
import onelove from "../../asset/onelove.png"
import crystalhotel from "../../asset/crystalhotel.png"
import logistichub from "../../asset/logistichub.png"
import Footer from "../../components/footer"
import { Icon } from '@iconify/react';

const Index = () => {
    return (
        <div className='portfolioWrapper screen-height'>
        <div className='container bg-black'>
            <Header/>
            <div className='container titleText'>
            <h2><span>Projects</span></h2>
            </div>
            <Row justify='space-around'>
            <Col lg={8} xs={24} sm={12}>
             <Card hoverable  className='portCard' style={{backgroundColor:"#f0f6f7"}}
                 actions={[
                    <a href='https://vendexpress.ng/' rel='noreferrer' target="_blank" > View</a>,
                  ]}>
               <div className='imgHolder'>
            <img src={vendexpresslogo} alt="vend express logo" style={{width: "30%"}}/>
            {/* <p>Vend Express</p> */}
            </div>
            <p>Technologies used: <b>ReactJs,<br/>Redux, ANTD,<br/>Less, HTML5</b></p>
             </Card>
             </Col>
             <Col lg={8} xs={24} sm={12}>
             <Card hoverable  className='portCard' style={{backgroundColor: "#f0ddf8"}}
              actions={[
                <a href='https://logistichub.netlify.app/' rel='noreferrer' target="_blank" > View</a>,
              ]}
              >
               <div className='imgHolder'>
             <img src={logistichub} alt="Logistic hub"/>
            {/* <p>Logistic Hub</p> */}

            </div>
            <p>Technologies used: <b>HTML5,<br/>CSS3, Bootstrap,<br/>AOS</b></p>
             </Card>
             </Col>
             <Col lg={8} xs={24} sm={12}>
             <Card hoverable  className='portCard' style={{backgroundColor:"#f0f6f7"}}
              actions={[
                <a href='https://glowree-template-2.netlify.app/#mymusic' rel='noreferrer' target="_blank" > View</a>,
              ]}
              >
               <div className='imgHolder'>
                {/* <img src={crystalhotel} alt="crystalhotel logo" style={{width: "20%"}}/> */}
                <p className='pete'>Pete<span ></span></p>
                </div>
                <p>Technologies used: <b>HTML5,<br/>CSS3, Wow.js, AOS<br/>Bootstrap</b></p>
             </Card>
             </Col>
             </Row>
            
             <Row>
             <Col lg={8} xs={24} sm={12}>
             <Card hoverable  className='portCard' style={{backgroundColor: "#f0ddf8"}}
              actions={[
                <a href='https://glo-githubclone.netlify.app/' rel='noreferrer' target="_blank" > View</a>,
              ]}
              >
               <div className='imgHolder'>
               <Icon icon="simple-icons:github"  className='icon' width="30"/>
            <p>Github Clone</p>

            </div>
            <p>Technologies used: <b>HTML5,<br/>CSS3, JavaScript,<br/>Github graphql</b></p>
             </Card>
             </Col>
             <Col lg={8} xs={24} sm={12}>
            <Card hoverable  className='portCard'
               actions={[
                <a href='https://oneloves.netlify.app/' rel='noreferrer' target="_blank" > View</a>,
              ]}
              >
               <div className='imgHolder'>
             <img src={onelove} alt="onelove logo"/>
            {/* <p>one Love</p> */}

            </div>
            <p>Technologies used: <b>Jquery,<br/>Bootstrap, HTML5,<br/>CSS3</b></p>
             </Card>
             </Col>
             <Col lg={8} xs={24} sm={12}>
             <Card hoverable  className='portCard' style={{backgroundColor:"#f0f6f7"}}
              actions={[
                <a href='https://crystal-hotel.netlify.app/' rel='noreferrer' target="_blank" > View</a>,
              ]}
              >
               <div className='imgHolder'>
                <img src={crystalhotel} alt="crystalhotel logo" style={{width: "12%"}}/>
                <p>Crystal Hotel</p>
                </div>
                <p>Technologies used: <b>HTML5,<br/>CSS3, Wow.js, AOS<br/>Bootstrap</b></p>
             </Card>
             </Col>
             </Row>
             <Row>
            
            <Col lg={8} xs={24} sm={12}>
            <Card hoverable  className='portCard' 
              actions={[
                <a href='https://glo-calculator.netlify.app/' rel='noreferrer' target="_blank" > View</a>,
              ]}
              >
            <div className='imgHolder'>
            {/* <img src={fitcodelogo} alt="fitcodelogo"/> */}
            <h3>Caculator App</h3>
            </div>
            <p>Technologies used: <b>HTML5,<br/>CSS3,<br/>JavaScript</b></p>
             </Card>
             </Col>
            <Col lg={8} xs={24} sm={12}>
             <Card hoverable  className='portCard' style={{backgroundColor:"#f0f6f7"}}
              actions={[
                <a href='https://gloquiz.netlify.app/' rel='noreferrer' target="_blank" > View</a>,
              ]}
              >
               <div className='imgHolder'>
                {/* <img src={crystalhotel} alt="crystalhotel logo" style={{width: "20%"}}/> */}
                <h3>Quiz App</h3>
                </div>
                <p>Technologies used: <b>HTML5,<br/>CSS3,<br/>JavaScript</b></p>
             </Card>
             </Col>
             <Col lg={8} xs={24} sm={12}>
             <Card hoverable  className='portCard' style={{backgroundColor:"#f0f6f7"}}
              actions={[
                <a href='https://geosearcher.netlify.app/' rel='noreferrer' target="_blank" > View</a>,
              ]}
              >
               <div className='imgHolder'>
                {/* <img src={crystalhotel} alt="crystalhotel logo" style={{width: "20%"}}/> */}
                <h3>Geosearch App</h3>
                </div>
                <p>Technologies used: <b>HTML5,<br/>CSS3,<br/>JavaScript</b></p>
             </Card>
             </Col>
             </Row>
           
        </div>
        <Footer/>

        </div>
    );
}

export default Index;
